var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.4264 16H22.5736C18.9431 16 16 18.9431 16 22.5736V41.4264C16 45.0569 18.9431 48 22.5736 48H41.4264C45.0569 48 48 45.0569 48 41.4264V22.5736C48 18.9431 45.0569 16 41.4264 16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4977 26.4967C43.221 25.5151 42.4079 24.7383 41.3778 24.4737C39.5048 24 32 24 32 24C32 24 24.4952 24 22.6222 24.4737C21.5878 24.7383 20.7747 25.5151 20.498 26.4967C20 28.2806 20 31.9979 20 31.9979C20 31.9979 20 35.7151 20.498 37.4991C20.7747 38.4807 21.5878 39.2574 22.6222 39.522C24.491 40 32 40 32 40C32 40 39.5048 40 41.3778 39.522C42.4079 39.2574 43.221 38.4807 43.4977 37.4991C44 35.7151 44 31.9979 44 31.9979C44 31.9979 44 28.2806 43.4977 26.4967Z",
    fill: "#05141F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 36V28L36 32.0024L30 36Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.c2da9709cc505572dda58a2f9c7790a9.svg";
export { ForwardRef as ReactComponent };